import type { ReactNode } from "react";

/**
 * Pecas de formulario comprido, em que a pessoa corrige o que ja existe (Gerenciar plano, spec 037): blocos com
 * titulo, o campo que mudou marcado com o valor de antes, e a lista do que foi salvo.
 */

/**
 * Um bloco do formulario (Plano, Etapa, Conta). E um `fieldset`: o leitor de tela anuncia o titulo ao entrar, e o
 * e2e acha o bloco por `getByRole("group", { name })`.
 */
export function BlocoDeFormulario({ titulo, descricao, children }: { titulo: string; descricao?: ReactNode; children?: ReactNode }) {
  return (
    <fieldset className="mtc-bloco">
      <legend className="mtc-bloco__titulo">{titulo}</legend>
      <div className="mtc-bloco__corpo">
        {descricao && <p className="mtc-bloco__descricao">{descricao}</p>}
        {children}
      </div>
    </fieldset>
  );
}

/**
 * Marca um campo que mudou em relacao ao que esta salvo: barra de acento ao lado e, embaixo, o valor de antes. Quem
 * decide se mudou e a tela (comparando com o que o backend mandou); aqui so o desenho.
 */
export function CampoMudado({ mudou, antes, children }: { mudou: boolean; antes?: ReactNode; children: ReactNode }) {
  return (
    <div className={`mtc-mudanca${mudou ? " mtc-mudanca--mudou" : ""}`} data-mudou={mudou || undefined}>
      {children}
      {mudou && (
        <span className="mtc-mudanca__antes">
          <span className="mtc-mudanca__selo">Mudou</span>
          Antes: {antes ?? "vazio"}
        </span>
      )}
    </div>
  );
}

export type MudancaSalva = { campo: string; rotulo: string; antes: string | null; depois: string | null };

/** O que foi salvo, campo a campo, como o backend devolveu ("Plataforma: Profit One para Profit Pro"). */
export function ListaDeMudancas({ itens, rotulo = "O que mudou" }: { itens: MudancaSalva[]; rotulo?: string }) {
  return (
    <ul className="mtc-mudancas" aria-label={rotulo}>
      {itens.map((m) => (
        <li key={m.campo}>
          <strong>{m.rotulo}</strong>: {m.antes ?? "vazio"} para {m.depois ?? "vazio"}
        </li>
      ))}
    </ul>
  );
}
